{
  "default": "en",
  "languages": {
    "en": "English",
    "fr": "Français"
  }
}
